/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DailyReturn } from '../models/DailyReturn';
import type { PerformanceMetrics } from '../models/PerformanceMetrics';
import type { PerformanceResponse } from '../models/PerformanceResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PerformanceService {
    /**
     * Get Performance
     * Get portfolio performance data.
     *
     * Returns metrics, chart data, and breakdown for the specified period.
     *
     * This endpoint is admin-only (requires authentication and admin privileges).
     * @returns PerformanceResponse Successful Response
     * @throws ApiError
     */
    public static getPerformanceApiV1PerformanceGet({
        period = 'All',
        showDeltaNotional = false,
    }: {
        /**
         * Time period: 1W, 1M, 3M, 6M, 1Y, MTD, YTD, All
         */
        period?: string,
        /**
         * Show delta-adjusted notional
         */
        showDeltaNotional?: boolean,
    }): CancelablePromise<PerformanceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/performance',
            query: {
                'period': period,
                'show_delta_notional': showDeltaNotional,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Performance Chart
     * Get chart data only (lighter endpoint for chart updates).
     * @returns DailyReturn Successful Response
     * @throws ApiError
     */
    public static getPerformanceChartApiV1PerformanceChartGet({
        period = 'All',
        showDeltaNotional = false,
    }: {
        /**
         * Time period: 1W, 1M, 3M, 6M, 1Y, MTD, YTD, All
         */
        period?: string,
        /**
         * Show delta-adjusted notional
         */
        showDeltaNotional?: boolean,
    }): CancelablePromise<Array<DailyReturn>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/performance/chart',
            query: {
                'period': period,
                'show_delta_notional': showDeltaNotional,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Performance Metrics
     * Get metrics only (lighter endpoint for summary cards).
     * @returns PerformanceMetrics Successful Response
     * @throws ApiError
     */
    public static getPerformanceMetricsApiV1PerformanceMetricsGet({
        period = 'All',
        showDeltaNotional = false,
    }: {
        /**
         * Time period
         */
        period?: string,
        /**
         * Show delta-adjusted notional
         */
        showDeltaNotional?: boolean,
    }): CancelablePromise<PerformanceMetrics> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/performance/metrics',
            query: {
                'period': period,
                'show_delta_notional': showDeltaNotional,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Best Worst Trades
     * Get best and worst individual trades.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getBestWorstTradesApiV1PerformanceBestWorstGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/performance/best-worst',
        });
    }
}
